import React, { useEffect, useState } from 'react'
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import TagListComponent from './TagListComponent';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    height: 'auto',
    minHeight: 300,
    bgcolor: 'white',
    border: '1px solid #000',
    p: 4,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
};

export default function UpdateTags() {
    const [open, setOpen] = useState(false);
    const [selectedTagName, setSelectedTagName] = useState('');
    const [selectedTagId, setSelectedTagId] = useState('');
    const [newTagName, setNewTagName] = useState('');
    const {
        fetchTags,
        tags,
        tagsLoading,
        updateTag,
    } = useTagsHook();
    
    useEffect(() => {
        fetchTags();
    }, [])
    
    if (tagsLoading === true || tags === null) {
        return <div className='flex justify-center items-center min-h-64'>
            <div className='text-xl font-semibold text-gray-600'>Loading...</div>
        </div>
    };
    
    const handleClose = () => {
        setOpen(false);
        setNewTagName('');
        setSelectedTagName('');
        setSelectedTagId('');
    };
    
    const handleUpdate = async () => {
        if (newTagName.trim() === '') {
            return;
        }
        await updateTag(selectedTagName, newTagName);
        handleClose();
    };
    
    return (
        <div className='flex justify-start items-center flex-col min-h-screen bg-gray-50 py-8'>
          <h1 className='text-3xl font-bold my-8 text-gray-800'>
                Update Tag
            </h1>
            <p className='text-lg text-gray-600 mb-8'>Select the tag you want to update</p>
            
            <div className='flex justify-center items-center flex-wrap gap-4 max-w-6xl px-4'>
                {tags.data.map((tag: any, index: number) => {
                    return (
                        <TagListComponent
                            key={index}
                            tag={tag}
                            tagIndex={index}
                            type='UPDATE'
                            onClick={() => {
                                const tagName = typeof tag === 'string' ? tag : tag.tagTitle || tag.title || tag.name || tag;
                                setSelectedTagName(tagName);
                                setSelectedTagId(tagName); // Backend sadece tagName bekliyor
                                setNewTagName(tagName); // Mevcut tag adını input'a set et
                                setOpen(true);
                            }}
                        />
                    )
                })}
            </div>
            
            {tags.data.length === 0 && (
                <div className='text-lg text-gray-500 mt-8'>
                    No tags added yet.
                </div>
            )}
            
            <Modal
                BackdropProps={{
                    style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
                }}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                open={open}
                onClose={handleClose}>
                <Box sx={style}>
                    <Typography variant="h6" component="h2" className="mb-4">
                        Update Tag
                    </Typography>
                    <Typography sx={{ mt: 2, mb: 3 }}>
                        Current tag: <span className='font-bold text-blue-600'>{selectedTagName}</span>
                    </Typography>
                    
                    <TextField
                        label='New Tag Name'
                        variant='outlined'
                        fullWidth
                        style={{ marginBottom: '24px' }}
                        type="text"
                        placeholder='Enter new tag name'
                        value={newTagName}
                        onChange={(e) => setNewTagName(e.target.value)}
                    />
                    
                    <div className='flex justify-evenly items-center mt-4 w-full'>
                        <Button
                            onClick={handleUpdate}
                            disabled={newTagName.trim() === '' || newTagName === selectedTagName}
                            color='primary'
                            variant='contained'
                            className='mt-4 ml-4 w-32'>
                            Update
                        </Button>
                        <Button
                            onClick={handleClose}
                            variant='outlined'
                            className='mt-4 w-32'>
                            Cancel
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}
